<template>
  <div
    :class="[
      'rootDiv reverseImage',
      'd-flex',
      $route.name == 'ManageCard' && reverseImageURL == ''
        ? 'justify-center align-center'
        : 'justify-end align-end',
    ]"
    ref="businesscardContainer"
    v-resize="getBusinessCardWidth"
    :style="`
   
    height: ${businessCardHeight}px; 
    border-radius: ${businessCardBorderRadius}px; 
    background-image:url('${reverseImageURL}');
    `"
  >
    <!--Start: Show the text only on manage card page for the back of card--->
    <template v-if="$route.name == 'ManageCard' && reverseImageURL == ''">
      <div class="grey--text text-center">
        Add your design to the <br />
        back of your card
      </div>
    </template>
    <!--End: Show the text only on manage card page for the back of card--->

    <div
      v-if="reverseCardLink != ''"
      class="lighten-4 d-flex justify-center text-center cursor-pointer"
      :style="`background-color: #C5CDDA;height: ${openLinkContainerSize}px; width:${openLinkContainerSize}px; border-radius: 4px; margin-right:4px;margin-bottom:4px;`"
      @click="openLink()"
    >
      <v-icon :size="openLinkIconSize" color="white">mdi-link-variant</v-icon>
    </div>
  </div>
</template>
<script>
export default {
  name: "BusinessCardBack",
  props: {
    reverseImageURL: {
      type: String,
      default: "",
    },
    cardCorners: {
      type: String,
      default: "card-corners-curved",
    },
    reverseCardLink: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      x: 0,
    };
  },
  computed: {
    businessCardHeight() {
      return this.x * (250 / 378); //* 0.66;
    },
    businessCardBorderRadius() {
      if (this.cardCorners == "card-corners-curved") return this.x * 0.02646;
      else if (this.cardCorners == "card-corners-square") return 0;
    },
    openLinkIconSize() {
      return this.x * 0.055;
    },
    openLinkContainerSize() {
      return this.x * 0.089;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getBusinessCardWidth();
    });
    setTimeout(() => {
      this.getBusinessCardWidth();
    }, 1);
  },
  methods: {
    getBusinessCardWidth() {
      if (this.$refs.businesscardContainer != null)
        this.x = this.$refs.businesscardContainer.clientWidth;
    },
    openLink() {
      if (this.reverseCardLink != "")
        window.open(this.reverseCardLink, "_blank");
    },
  },
};
</script>
<style scoped>
.rootDiv {
  --webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.reverseImage {
  /* Full height */
  height: 100%;
  /* Center and scale the image properly */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
